// extracted by mini-css-extract-plugin
export default {"category":"Category_category__3yR00","quizChallenges":"Category_quizChallenges__Dob4p"};